var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.photoArray)?_c('viewer',{ref:"viewer",attrs:{"eagle-photo-viewer":"root"}},_vm._l((_vm.photoArray),function(photoObject,index){return _c('img',{key:index,attrs:{"alt":photoObject.name,"src":_vm.getPhotoUrl(photoObject)}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }